import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { genKey } from "../../../../../../helpers/keys.js";
import { nullFunction } from "../../../../../../helpers/null.js";
import TabButtonView from "../../components/TabButtonView/index.js";
import useTabs from "../../hooks/useTabs.js";
import * as SS from "../../styled.js";
import * as S from "./styled.js";
const Tabs = ({ orientation , selectedTab , sliderProps , verticalMaxWidth , children  })=>{
    if (orientation === 'horizontal') {
        return /*#__PURE__*/ _jsx(SS.TabsCarousel, {
            "aria-orientation": orientation,
            autoWidth: true,
            wheels: true,
            omitEnd: true,
            pagination: false,
            start: selectedTab,
            ...sliderProps,
            role: "tablist",
            children: children
        });
    }
    if (orientation === 'vertical') {
        return /*#__PURE__*/ _jsx(SS.TabsVerticalWrapper, {
            role: "tablist",
            $maxWidth: verticalMaxWidth,
            children: children
        });
    }
    return null;
};
export const TabsDesktop = ({ className ='tabs-component' , tabs =[] , selectedTab: propsSelectedTab = 0 , onClick , orientation ='horizontal' , verticalMaxWidth ='calc(100% / 3)' , sliderProps , showOnlyOneTab =true , preRenderTabs =false , ...rest })=>{
    const { selectedTab , visibleTabs  } = useTabs(tabs, propsSelectedTab);
    const showTabs = showOnlyOneTab ? true : tabs.length > 1;
    return /*#__PURE__*/ _jsxs(SS.TabsStyled, {
        "data-testid": "Tabs",
        className: className,
        $orientation: orientation,
        ...rest,
        children: [
            showTabs && /*#__PURE__*/ _jsx(Tabs, {
                orientation: orientation,
                selectedTab: selectedTab,
                sliderProps: sliderProps,
                verticalMaxWidth: verticalMaxWidth,
                children: tabs.map((tab, id)=>/*#__PURE__*/ _jsx(TabButtonView, {
                        tab: tab,
                        className: className,
                        selectedTab: selectedTab,
                        onClick: !tab.data?.isLink ? onClick ?? nullFunction : nullFunction,
                        orientation: orientation
                    }, genKey(`${tab.index}${id}TabButtonView`)))
            }),
            /*#__PURE__*/ _jsx(S.TabsWrapper, {
                $orientation: orientation,
                role: "tabpanel",
                "aria-labelledby": `btn-${selectedTab}`,
                id: `tabpanel-${selectedTab}`,
                children: (preRenderTabs ? tabs : visibleTabs.map((visibleTab)=>tabs[visibleTab])).map((tab, id)=>/*#__PURE__*/ _jsx(SS.TabsContent, {
                        className: classNames({
                            'is-active': selectedTab === tab.index
                        }),
                        children: tab.element
                    }, genKey(`${tab.index}${id}TabsContent`)))
            })
        ]
    });
};
export default TabsDesktop;

//# sourceMappingURL=index.js.map